// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__YqBWW","Arcade_wrapper":"style_Arcade_wrapper__ChS_T"};